import { createApp } from "vue";
import { i18n } from "i18n";
import vui from "vui";
import App from "App";

const el = document.getElementById("index");

const app = createApp(App, {
	srvs: JSON.parse(el.dataset.srvs),
	ccy: el.dataset.ccy
});

app.use(i18n);
app.use(vui);

app.mount(el);
